import { ListMusic, ListPlus, Plus } from "lucide-react";
import React, { useState } from "react";
import { usePlayerStore } from "../../stores/playerStore";
import { usePlaylistStore } from "../../stores/playlistStore";
import { useRightSidebarStore } from "../../stores/rightSidebarStore";

export const AddToPlaylist = () => {
  const [newPlaylistName, setNewPlaylistName] = useState("");
  const { playlists, createPlaylist, addTrackToPlaylist } = usePlaylistStore();
  const { currentTrack } = usePlayerStore();
  const { closeSidebar } = useRightSidebarStore();

  const handleAddToPlaylist = (playlistId: string) => {
    if (!currentTrack) return;

    const playlist = playlists.find((p) => p.id === playlistId);
    if (!playlist || playlist.tracks.some((t) => t.id === currentTrack.id)) {
      return; // Track already exists in playlist
    }

    addTrackToPlaylist(playlistId, currentTrack);
  };

  const handleCreatePlaylist = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPlaylistName.trim() || !currentTrack) return;

    const playlistId = createPlaylist(newPlaylistName);
    addTrackToPlaylist(playlistId, currentTrack);
    setNewPlaylistName("");
  };

  return (
    <div className="p-6 space-y-6">
      {playlists.length === 0 ? (
        <div className="flex flex-col items-center justify-center text-center space-y-4 bg-zinc-800/50 p-8 rounded-lg">
          <ListPlus className="w-16 h-16 text-zinc-500" />
          <div>
            <h3 className="text-lg font-semibold mb-2">No Playlists Yet</h3>
            <p className="text-zinc-400 mb-4">Create your first playlist and start curating your music</p>
          </div>
        </div>
      ) : (
        <>
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <ListMusic className="w-5 h-5" />
            Your Playlists
          </h3>
          <div className="space-y-2">
            {playlists.map((playlist) => {
              const hasTrack = currentTrack && playlist.tracks.some((t) => t.id === currentTrack.id);
              return (
                <button
                  key={playlist.id}
                  onClick={() => handleAddToPlaylist(playlist.id)}
                  disabled={hasTrack}
                  className={`w-full px-4 py-3 text-left rounded-lg transition flex items-center justify-between ${
                    hasTrack ? "bg-zinc-800/50 text-zinc-500 cursor-not-allowed" : "bg-zinc-800 hover:bg-zinc-700"
                  }`}
                >
                  <span>{playlist.name}</span>
                  <span className="text-sm text-zinc-400">{playlist.tracks.length} tracks</span>
                </button>
              );
            })}
          </div>
        </>
      )}

      <div className="pt-6 border-t border-zinc-800">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <Plus className="w-5 h-5" />
          Create New Playlist
        </h3>
        <form onSubmit={handleCreatePlaylist} className="flex gap-2">
          <input
            type="text"
            value={newPlaylistName}
            onChange={(e) => setNewPlaylistName(e.target.value)}
            placeholder="Playlist name"
            className="flex-1 px-4 py-2 bg-zinc-800 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />
          <button
            type="submit"
            disabled={!newPlaylistName.trim()}
            className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Create
          </button>
        </form>
      </div>
    </div>
  );
};
